'use strict';

var lastWindowWidth = $(window).width();
var slickConfigs = {
    heroBanner: {
        desktop: {
            dots: true,
            infinite: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
        },
        mobile: {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    },
    articleTiles: {
        desktop: {
            dots: false,
            infinite: false,
            arrows: true,
            slidesToShow: 2.47,
            slidesToScroll: 1
        },
        mobile: {
            dots: true,
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
};

/**
 * Given a jQuery object pointing at a carousel, returns the
 * correct configuration from slickConfigs.
 *
 * @param {jQuery} $carousel - The jQuery object pointing at
 * the carousel.
 * @returns {Object|null} The object from slickConfigs that
 * corresponds to the given carousel, or null if the type of
 * carousel is not recognized.
 */
function getCarouselConfig($carousel) {
    if ($carousel.hasClass('hero-banner-layout')) {
        return slickConfigs.heroBanner;
    }
    if ($carousel.hasClass('article-tiles-layout')) {
        return slickConfigs.articleTiles;
    }
    return null;
}

/**
 * Initializes all carousels with the class "blogs-herocarousel" with the
 * correct configuration settings. The correct configuration is determined
 * by the presence of the classes "hero-banner-layout" or
 * "article-tiles-layout" on the carousel element. If the carousel is already
 * initialized, it is first destroyed before being reinitialized.
 * @function
 */
function initBlogCarousel() {
    $('.blogs-herocarousel').each(function () {
        var $carousel = $(this);
        var config = getCarouselConfig($carousel);
        if (!config) return;
        var isMobile = window.innerWidth < 768;
        var settings = isMobile ? config.mobile : config.desktop;
        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }
        $carousel.slick(settings);
    });
}

$(window).on('resize', function () {
    const currentWidth = $(window).width();
    if (currentWidth !== lastWindowWidth) {
        lastWindowWidth = currentWidth;
        initBlogCarousel();
    }
});

module.exports = {
    initBlogCarousel: initBlogCarousel
};
